import localize from '@/filters/localize';
import methods from '@/helpers/methods';

const selector = '.copy-to-clipboard';

function getCopyElement(event) {
  return event.target.closest(selector);
}

function getText(element) {
  if ('value' in element && typeof element.value === 'string') {
    return element.value;
  }

  return element.textContent;
}

async function copy(event) {
  const element = getCopyElement(event);
  if (!element) return;

  event.stopPropagation();

  try {
    await methods.copyToClipboard(getText(element));
    methods.showGlobalSnackbar('success', localize('commentCopied'));
  } catch {
    methods.showGlobalSnackbar('error', localize('commentCopyFailed'));
  }
}

export default function enableClipboardCopy() {
  document.addEventListener('click', copy);
}
